import { render, staticRenderFns } from "./LeftTextRadio.vue?vue&type=template&id=c63cb89a&scoped=true"
import script from "./LeftTextRadio.vue?vue&type=script&lang=js"
export * from "./LeftTextRadio.vue?vue&type=script&lang=js"
import style0 from "./LeftTextRadio.vue?vue&type=style&index=0&id=c63cb89a&prod&scoped=true&lang=scss"
import style1 from "./LeftTextRadio.vue?vue&type=style&index=1&id=c63cb89a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63cb89a",
  null
  
)

export default component.exports